import $ from 'jquery';

import StaticAddresses from '../sections/StaticAddresses';

export default class Account {
  constructor(section) {
    this.$el = $(section.el);
    $('.toggle-forgetfulness span', this.$el).on('click', () => this.recoverPassword());

    if ($(document.body).hasClass('template-customers-addresses')) {
      this.StaticAddresses = new StaticAddresses({ el: ($('.main-content')) });
    }

    if ($(document.body).hasClass('template-customers-login')) { this.checkForReset(); }
    if (window.location.hash === '#recover') { this.recoverPassword(); }
  }

  recoverPassword() {
    $('.recover-password', this.$el).toggle();
    $('.customer-login', this.$el).toggle();
  }

  checkForReset() {
    if ($('.reset-check').data('successful-reset') === true) {
      $('.successful-reset').show();
    }
  }
}
